// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3qPpn","left":"InfoRow_left__1WVJW"};